import { useEffect, useRef, useState } from "react";
import { Box, Button, Divider, Grid } from "@mui/material";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { useAuthStore } from "hooks/useAuthStore";
import { toast } from "react-toastify";
import { UserInput } from "./components/userInput";
import { PasswordIput } from "./components/passwordIput";
import { Options } from "./components/options";
import { Recaptcha } from "./components/recaptcha";
import ReCAPTCHA from "react-google-recaptcha";
import { encriptaDatos } from "helpers/herramientas/bcryptjs";
import { Ayuda } from "./components/ayuda";
import { CrearCuenta } from "./components/crearCuenta";
import { CursosCapacitacion } from "./components/cursosCapacitacion";
import { ModalVideoApp } from "./components/modalVideoApp";

type Inputs = {
  user: string;
  password: string;
  ipUsuario: null;
  ipPublica: null;
  longitud: null;
  latitud: null;
  cveTipoDispositivo: null;
};

export const FormLogin = () => {
  const methods = useForm<Inputs>();
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const { startLogin, errorMessage } = useAuthStore();
  const [disabledButton, setDisabledButton] = useState(true);

  const notify = () =>
    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
    });

  useEffect(() => {
    if (errorMessage !== null) {
      notify();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorMessage]);

  useEffect(() => {
    methods.setValue("ipUsuario", null, { shouldDirty: true });
    methods.setValue("ipPublica", null, { shouldDirty: true });
    methods.setValue("longitud", null, { shouldDirty: true });
    methods.setValue("latitud", null, { shouldDirty: true });
    methods.setValue("cveTipoDispositivo", null, { shouldDirty: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeRecaptcha = (value: any) => {
    if (value) {
      setDisabledButton(false);
    }
  };

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    data.password = encriptaDatos(data.password, 8);
    startLogin(data);
    localStorage.setItem("lastpath", "/dashboard/inicio");
    localStorage.setItem("selectedIndex", "1");
  };

  return (
    <>
        <FormProvider {...methods}>
      <form
        className="w-full"
        autoComplete="off"
        onSubmit={methods.handleSubmit(onSubmit)}
      >
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <UserInput />
          </Grid>
          <Grid item xs={12}>
            <PasswordIput />
          </Grid>
          <Grid item xs={12}>
            <Recaptcha
              recaptchaRef={recaptchaRef}
              handleChangeRecaptcha={handleChangeRecaptcha}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="error"
              className="my-3 w-full"
              type="submit"
              disabled={disabledButton}
            >
              Iniciar Sesión
            </Button>
          </Grid>
        </Grid>
        <Grid container className="mt-4">
          <Options />
        </Grid>
        <Box component="div" sx={{ mt: 3, width: "100%" }}>
          <CrearCuenta />
        </Box>
        <Box component="div" sx={{ mt: 8, width: "100%" }}>
          <Ayuda />
        </Box>
      </form>
    </FormProvider>
    <ModalVideoApp/>
    </>

    
  );
};
